export const colors = {
  correct: '#336611',
  error: '#661133',
  incorrect: '#212121',
  /* Misplaced is drawn as an outline rather than a fill: red/green colourblind
   * players cannot separate a green "correct" tile from an amber "misplaced"
   * one by colour alone, so the dashed border carries the meaning instead. */
  misplaced: 'rgb(214 133 0)',
  /* The old filled style, kept only so historical changelog entries still
   * illustrate what the game actually looked like at the time. */
  misplacedLegacy: '#996611',
};
